import { render, staticRenderFns } from "./UserGuideEditor.vue?vue&type=template&id=706eada4&"
import script from "./UserGuideEditor.vue?vue&type=script&lang=ts&"
export * from "./UserGuideEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports